<template>
  <div>
    <v-container class="p-0">
      <v-row>
        <v-col v-if="intervals.length > 0 && !allDay" class="pr-0 pl-2 text-center interval-chips">
          <v-chip 
            class="interval-chip ma-2"
            v-for="(interval, index) in intervals" 
            v-bind:key="`interval-${index}`"
            closable
            @click:close="removeInterval(index)"
          >{{`${interval.timeFrom} – ${interval.timeTo}`}}</v-chip>
        </v-col>
        <v-col 
          v-else 
          class="text-center p-4 pr-0 pl-4 interval-no-chips">
          {{`${allDay ? '0:00 — 23:59' : 'nezobrazováno'}`}}
        </v-col>
        <v-col v-if="!allDay" class="add-column">
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col class="pl-6 pt-1 pb-0">
                  <time-picker
                    :id="idInput1"
                    :neighborId="idInput2"
                    title="Od"
                    :clearable="true"
                    :rules="[required_rule]"
                    @time-changed="newTime => interval.timeFrom = newTime"
                    ref="fromPicker"
                    condensed
                  ></time-picker>
                </v-col>
                <v-col class="pt-1 pb-0">
                  <time-picker
                    :id="idInput2"
                    :neighborId="idInput1"
                    title="Do"
                    :clearable="true"
                    :rules="[required_rule]"
                    @time-changed="newTime => interval.timeTo = newTime"
                    v-on:trySubmit="() => valid && addInterval()"
                    :minTime="interval.timeFrom"
                    ref="toPicker"
                    condensed
                  ></time-picker>
                </v-col>
                <v-col class="p-0 pt-2 add-interval-button">
                  <v-btn 
                    class="mt-0 mr-1 btn-small" 
                    rounded
                    color="primary" 
                    small
                    @click="addInterval"
                    :disabled="!valid">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-col>
        <v-col class="text-center all-day-column">
          <v-checkbox 
            :id="`announcement-all-day-${dayOfWeek}`"
            v-model="allDay" 
            :hide-details="true" 
            label="Celý den" 
            :true-value="true"
            :false-value="false"
            dense>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import TimePicker from "../time-picker/TimePickerForDisplays.vue";
import {computed, reactive, ref, watch} from "vue";

const props = defineProps({
  dayOfWeek: Number,
  initialValues: Array,
  allDayInitial: Boolean
})

const emit = defineEmits(['intervalsChanged'])

const allDay = ref(props.allDayInitial ? props.allDayInitial : false)
const valid = ref(false)
const interval = reactive({
  dayOfWeek: props.dayOfWeek ? props.dayOfWeek : undefined,
  timeFrom: undefined,
  timeTo: undefined
})
const intervals = ref(props.initialValues ? props.initialValues : [])
const idInput1 = ref(`time-picker_${self.crypto.randomUUID()}`)
const idInput2 = ref(`time-picker_${self.crypto.randomUUID()}`)
const form = ref(null)
const fromPicker = ref(null)
const toPicker = ref(null)

const required_rule = (value) => {
  return !!value || 'Povinné'
}

const outputObject = computed(()=>{
  return allDay.value ? [{
    dayOfWeek: props.dayOfWeek ? props.dayOfWeek : undefined,
    timeFrom: '00:00',
    timeTo: '23:59'
  }] : intervals.value;
})

const overflowConflict = computed(()=>{
  return !!(intervals.value.find(
      item => (interval.timeFrom >= item.timeFrom && interval.timeFrom <= item.timeTo) ||
          (interval.timeTo >= item.timeFrom && interval.timeTo <= item.timeTo) ||
          (interval.timeFrom <= item.timeFrom && interval.timeTo >= item.timeTo)))
})

function addInterval(){
  if (!overflowConflict.value || confirm("Časový interval překrývá již existující, chcete pokračovat?")) {
    intervals.value.push({ ...interval });
    form.value.reset();
    fromPicker.value.reset();
    toPicker.value.reset();
    Object.assign(interval,{
      dayOfWeek: props.dayOfWeek ? props.dayOfWeek : undefined,
      timeFrom: undefined,
      timeTo: undefined
    })
  }
}

function removeInterval(index) {
  intervals.value.splice(index, 1)
}

watch(outputObject, (newOutputObject) => {
  emit('intervalsChanged', newOutputObject)
},{
  deep: true
})
</script>

<style scoped>
.all-day-column {
  max-width: 140px; 
  min-width: 140px; 
  margin: auto;
}

.interval-chip {
  min-width: 135px;
}

.add-column {
  min-width: 240px;
}

.add-interval-button {
  max-width: 70px;
}

.interval-no-chips {
  word-break: break-all;
  margin: auto;
}

.interval-chips {
  min-width: unset;
}

.v-input--checkbox {
  margin: 0;
  padding: 0;
}
</style>